import SecaoGrupoDeImportadores from './SecaoGrupoDeImportadores';

export { SecaoGrupoDeImportadores };

export default SecaoGrupoDeImportadores;
